import { useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import mittEmitter from '../utils/mitt'

const useAppNavigation = () => {
  const navagate = useNavigate()
  const navigationRef = useRef(navagate)

  /**Navigation effect */
  useEffect(() => {
    const navigationEventHandler = (url: string) => {
      if (url) {
        Office.addin
          .showAsTaskpane()
          .then(() =>
            navigationRef.current(url === window.location.pathname ? '/' : url)
          )
      }
    }

    mittEmitter.on('Navigation', navigationEventHandler)
    return () => {
      mittEmitter.off('Navigation', navigationEventHandler)
    }
  }, [])
}

export default useAppNavigation
